import React from "react";
import { HiRefresh } from "react-icons/hi";

interface CacheInProgressIndicatorProps {
  size?: "sm" | "md" | "lg";
  customText?: string;
}

/**
 * Component that displays a loading indicator with an animation and text
 * specifically for "cache_in_progress" status.
 */
const CacheInProgressIndicator: React.FC<CacheInProgressIndicatorProps> = ({
  size = "md",
  customText = "Please wait"
}) => {
  // Define icon sizing based on the size prop
  const getIconSize = () => {
    switch (size) {
      case "sm": return "h-4 w-4";
      case "lg": return "h-6 w-6";
      case "md":
      default: return "h-5 w-5";
    }
  };

  // Define text sizing based on the size prop
  const getTextSize = () => {
    switch (size) {
      case "sm": return "text-xs";
      case "lg": return "text-base";
      case "md":
      default: return "text-sm";
    }
  };

  return (
    <div className="flex items-center gap-2">
      <HiRefresh className={`${getIconSize()} text-purple-500 animate-spin`} />
      {customText && (
        <span className={`${getTextSize()} text-purple-600 dark:text-purple-400`}>
          {customText}
        </span>
      )}
    </div>
  );
};

export default CacheInProgressIndicator; 